import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { LicenseManager } from 'ag-grid-enterprise';
import { UserService } from '../../shared/services/user.service';
import { AppraisalDataService } from '../../shared/services/appraisal-data.service';
import { environment } from '../../../environments/environment';
import { ApprovalStatus } from '../../models/appraisal';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-change-history',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './change-history.component.html',
  styleUrl: './change-history.component.scss'
})
export class ChangeHistoryComponent implements OnInit {
  userData: any = {};
  historyDetails: any = {};
  activityNumber!: string;
  constructor(private http: HttpClient, private route: ActivatedRoute, private appraisalDataService: AppraisalDataService, private userService: UserService) {
      LicenseManager.setLicenseKey("Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-060398}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Cushman_&_Wakefield_Global,_Inc}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Charts_and_AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{18_June_2025}____[v3]_[0102]_MTc1MDIwMTIwMDAwMA==e09d5ef40227227bc0761c5be7738da7");
  }
  ngOnInit(): void {
    this.activityNumber = this.route.snapshot.paramMap.get('id')!;
    this.userService.userData$.subscribe((data) => {
      this.userData = data;
      if (this.userData)
        this.fetchData(this.activityNumber);
    });
  }

  fetchData(activityNumber: string): void {
      const apiUrl = environment.appraisalApiConfig.baseUrl + '/changeHistory/' + activityNumber; // API endpoint
      this.http.get<ApprovalStatus[]>(apiUrl).subscribe(
        (result) => {
          this.historyDetails = result;
        },
        (error) => {
          console.error('Error fetching data:', error);
        }
      );
    }
}
